import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getTranslate } from '../../../Helper/GetTranslate';

export class ComparasionChartSolutions extends Component {
    render() {

        const translate = getTranslate().solutions.banner;
        return (
            <>


                <section className="call-to-action mt-5">

                    <div className="container">
                        <div className="action-content text-center wow pixFadeUp">
                            <h2 className="title">
                               {translate.title}
                            </h2>

                            <p>
                               


                            </p>

                            <a href="https://partners.tourzone.com" rel="noreferrer" className="pix-btn btn-light">{translate.button}</a>
                        </div>

                    </div>




                </section>
            </>
        )
    }
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(ComparasionChartSolutions)